class BackupWindow {
    constructor() {
    }

    static fromRaw(raw) {
        let bkWin = new BackupWindow();
        bkWin.raw = raw;
        bkWin.uuid = raw.uuid;
        bkWin.name = raw.name;
        bkWin.timezone = raw.timezone;
        bkWin.description = raw.description;
        bkWin.backupWindowSpecifics = raw.backupWindowSpecifics ? raw.backupWindowSpecifics.map(sj => BackupWindowSpecifics.fromRaw(sj)) : [];

        return bkWin;
    }

    toRaw() {
        return { name: this.name, description: this.description, timezone: this.timezone, backupWindowSpecifics: this.backupWindowSpecifics.map(bws => this.toSpecificRow(bws)) };

    }

    toSpecificRow(bws) {
        return { dayOfWeek: bws.dayOfWeek, windowStartTime: bws.windowStartTime, windowEndTime: bws.windowEndTime };
    }
}

class BackupWindowSpecifics {
    constructor() {
    }

    static fromRaw(raw) {
        let bkWinS = new BackupWindowSpecifics();
        bkWinS.raw = raw;
        bkWinS.dayOfWeek = raw.dayOfWeek;
        bkWinS.windowStartTime = raw.windowStartTime;
        bkWinS.windowEndTime = raw.windowEndTime;

        return bkWinS;
    }

    toRaw() {
        return {
            dayOfWeek: this.dayOfWeek,
            windowStartTime: this.windowStartTime,
            windowEndTime: this.windowEndTime
        }
    }
}

module.exports = BackupWindow;


// WEBPACK FOOTER //
// ./src/azurebackup/model/BackupWindow.js